import { useGetExpSettingCurrency } from "queries/useGetExpSettingCurrency";
import LoyaltyInfoExperience from "components/atoms/LoyaltyInfoExperience";

export const LoyaltyInfoExperienceContainer = () => {
  const { exp, currency } = useGetExpSettingCurrency();
  const amount = exp?.amount?.toFixed(0) || "0";
  const cost = exp?.cost?.toFixed(0) || "0";

  return (
    <LoyaltyInfoExperience
      experience={amount}
      value={cost}
      currency={currency}
    />
  );
};
